// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../common/Components/IconV5.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function WizardNavigationVisuals$Holder(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "bg-zinc-50 border-b border-zinc-200 p-0 sm:pt-6 sm:pb-2.5 sm:px-0 sm:mb-5 lg:pt-9 lg:pb-2.5 lg:px-12 lg:mb-0"
  });
}

let Holder = {
  make: WizardNavigationVisuals$Holder
};

function style(active) {
  return TailwindMerge.twMerge([
    "text-center relative w-full flex-1 \n         before:content-[''] before:absolute before:left-0 before:right-1/2 before:top-6 before:h-0.5 \n         after:content-[''] after:absolute after:left-1/2 after:right-0 after:top-6 after:h-0.5 \n         first:before:bg-zinc-50 last:after:bg-zinc-50",
    "max-sm:p-2.5 max-sm:border-b max-sm:border-zinc-200 max-sm:last:border-b-0 max-sm:before:hidden max-sm:after:hidden max-sm:[&>a]:flex max-sm:[&>a]:items-center",
    active ? "max-sm:border-b-0 max-sm:[&~li]:hidden" : ""
  ]);
}

let Style = {
  style: style
};

let WizardStep = {
  Style: Style
};

function WizardNavigationVisuals$List(props) {
  return JsxRuntime.jsx("ul", {
    children: props.children,
    className: "list-none flex justify-between w-full pl-0 relative \n         before:content-[''] before:absolute before:left-0 before:right-0 before:top-6 before:h-0.5 before:bg-zinc-300 \n         mb-4 max-sm:flex-col max-sm:mb-0 max-sm:before:hidden"
  });
}

let List = {
  make: WizardNavigationVisuals$List
};

function bgClassOfState(stepState) {
  if (typeof stepState !== "object") {
    return "bg-zinc-300";
  }
  if (stepState.NAME === "active") {
    return "bg-tan-blue-500";
  }
  let match = stepState.VAL;
  if (match === "valid") {
    return "bg-tan-success";
  } else if (match === "invalid") {
    return "bg-tan-error-500";
  } else {
    return "bg-zinc-300";
  }
}

function textClassOfState(stepState) {
  if (stepState === "untouched") {
    return "text-zinc-700";
  } else {
    return "text-white";
  }
}

function sizeClassOfState(stepState) {
  if (typeof stepState === "object" && stepState.VAL !== "unknown") {
    return "text-sm";
  } else {
    return "text-lg w-6 h-6";
  }
}

function WizardNavigationVisuals$StepNumber(props) {
  let stepNumber = props.stepNumber;
  let stepState = props.stepState;
  let tmp;
  if (typeof stepState === "object") {
    let match = stepState.VAL;
    tmp = match === "valid" ? JsxRuntime.jsx(IconV5.make, {
        icon: "ok-circled",
        size: 24
      }) : (
        match === "invalid" ? JsxRuntime.jsx(IconV5.make, {
            icon: "cancel-circled",
            size: 24
          }) : stepNumber.toString()
      );
  } else {
    tmp = stepNumber.toString();
  }
  return JsxRuntime.jsx("span", {
    children: tmp,
    className: TailwindMerge.twMerge([
      "absolute right-2 top-1/2 -mt-3 rounded-full flex justify-center items-center text-center font-semibold sm:-top-2 sm:-right-2 sm:mt-0",
      bgClassOfState(stepState),
      textClassOfState(stepState),
      sizeClassOfState(stepState)
    ])
  });
}

let StepNumber = {
  bgClassOfState: bgClassOfState,
  textClassOfState: textClassOfState,
  sizeClassOfState: sizeClassOfState,
  make: WizardNavigationVisuals$StepNumber
};

function className(active) {
  return TailwindMerge.twMerge([
    "bg-white flex items-center justify-center w-[42px] h-[42px] rounded-full border-2 static text-center",
    "sm:relative sm:z-10 sm:mt-0 sm:mx-auto sm:mb-3 sm:w-[52px] sm:h-[52px]",
    active ? "text-tan-blue-500 border-tan-blue-500" : "text-zinc-500 border-zinc-300"
  ]);
}

function WizardNavigationVisuals$StepGraphic(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(IconV5.make, {
        icon: props.icon,
        size: 24
      }),
      JsxRuntime.jsx(WizardNavigationVisuals$StepNumber, {
        stepState: props.stepState,
        stepNumber: props.stepNumber
      })
    ],
    className: className(props.active)
  });
}

let StepGraphic = {
  className: className,
  make: WizardNavigationVisuals$StepGraphic
};

function WizardNavigationVisuals$Item(props) {
  let active = props.active;
  return JsxRuntime.jsx("li", {
    children: JsxRuntime.jsxs("button", {
      children: [
        JsxRuntime.jsx(WizardNavigationVisuals$StepGraphic, {
          icon: props.icon,
          stepState: props.stepState,
          stepNumber: props.stepNumber,
          active: active
        }),
        JsxRuntime.jsx("h5", {
          children: props.label,
          className: "mb-0 text-zinc-700 font-medium text-lg leading-6 sm:text-lg sm:leading-6"
        })
      ],
      className: "bg-transparent border-0 cursor-pointer flex items-center gap-x-2 sm:inline-block",
      onClick: props.onClick
    }),
    className: style(active)
  });
}

let Item = {
  make: WizardNavigationVisuals$Item
};

exports.Holder = Holder;
exports.WizardStep = WizardStep;
exports.List = List;
exports.StepNumber = StepNumber;
exports.StepGraphic = StepGraphic;
exports.Item = Item;
/* IconV5 Not a pure module */
